"use strict";
exports.__esModule = true;
exports.getSelectedOptionKeys = void 0;
var getSelectedOptionKeys = function (keys, items) {
    if (!keys || !items) {
        return [];
    }
    if (keys === "all") {
        return items.map(function (item) { return item.value; });
    }
    return Array.from(keys);
};
exports.getSelectedOptionKeys = getSelectedOptionKeys;
//# sourceMappingURL=getSelectedOptionKeys.js.map